import { toast as _toast } from 'react-toastify';

const KIND = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warn',
};

const FALLBACK_MESSAGE = 'Something went wrong. Please try again.';

const extract = (value) => {
  if (value === null || value === undefined) return [];
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed ? [trimmed] : [];
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return [String(value)];
  }
  if (value instanceof Error) {
    return value.message ? [value.message] : [];
  }
  if (Array.isArray(value)) {
    return value.flatMap(extract);
  }
  if (typeof value === 'object') {
    if (typeof value.detail === 'string' && value.detail.trim()) {
      return [value.detail.trim()];
    }
    return Object.values(value).flatMap(extract);
  }
  return [];
};

const messageFrom = (obj) => {
  const parts = extract(obj);
  return parts.length > 0 ? parts.join(' ') : FALLBACK_MESSAGE;
};

const show = (kind, obj) => {

  _toast.dismiss();

  const params = {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
  };

  _toast[kind](messageFrom(obj), params);
};

const contains = (target) => {
  const ancestor = target.closest('.Toastify');
  return ancestor && ancestor.contains(target);
};

const toast = {
  KIND,
  show,
  contains,
};

export default toast;